import KolkaOrnament from './KolkaOrnament'
import MaharajPortrait from './MaharajPortrait'
import StatCounter from '../../common/StatCounter'
import { useRevealClass } from '../../../hooks/useRevealClass'
import './AboutSection.css'
import { appUrl } from '@astro/config'

const EXPERTISE_CHIPS = ['Kundli Analysis', 'Vastu Shastra', 'Palmistry', 'Numerology', 'Vedic Remedies', 'Gem Therapy']

const RECOGNITION = ['Vedic Jyotish Samiti', 'All India Astrology Congress', 'Bharat Jyotish Mahasangh', "Int'l Vedic Institute"]

const stats = {
  session: 10,
  countries: 10,
  experience: 15
}

export default function AboutSection() {
  const portraitReveal = useRevealClass()
  const contentReveal = useRevealClass()

  return (
    <section
      id="about"
      className="relative py-20 lg:py-32 overflow-hidden"
      style={{ background: 'linear-gradient(180deg,#0B0806 0%,#0f0a07 50%,#0B0806 100%)' }}
    >
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <div
          className="absolute -top-32 -left-32 w-[55vw] max-w-160 h-[55vw] max-h-160 rounded-full"
          style={{ background: 'radial-gradient(circle,rgba(120,53,15,.18) 0%,transparent 70%)', filter: 'blur(80px)' }}
        />
        <div
          className="absolute -bottom-32 -right-32 w-[45vw] max-w-135 h-[45vw] max-h-135 rounded-full"
          style={{ background: 'radial-gradient(circle,rgba(161,88,10,.12) 0%,transparent 70%)', filter: 'blur(90px)' }}
        />
        <div className="absolute top-28 left-[18%] w-1 h-1 rounded-full bg-goldPrimary/30 animate-pulse" />
        <div className="absolute top-52 right-[22%] w-0.5 h-0.5 rounded-full bg-goldPrimary/20 animate-pulse" style={{ animationDelay: '.9s' }} />
        <div className="absolute bottom-36 left-[42%] w-1.5 h-1.5 rounded-full bg-goldPrimary/15 animate-pulse" style={{ animationDelay: '1.8s' }} />
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[min(900px,90vw)] h-px"
          style={{ background: 'linear-gradient(90deg,transparent,rgba(245,158,11,.18),transparent)' }}
        />
        <div
          className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[min(900px,90vw)] h-px"
          style={{ background: 'linear-gradient(90deg,transparent,rgba(245,158,11,.10),transparent)' }}
        />

        <KolkaOrnament corner="tl" />
        <KolkaOrnament corner="tr" />
        <KolkaOrnament corner="bl" />
        <KolkaOrnament corner="br" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
          <div
            ref={portraitReveal.ref}
            className={`lg:col-span-5 flex justify-center items-start reveal-left${portraitReveal.visible ? ' is-visible' : ''}`}
            style={{ transitionDelay: '.1s' }}
          >
            <MaharajPortrait />
          </div>

          <div
            ref={contentReveal.ref}
            className={`lg:col-span-7 space-y-6 reveal-right${contentReveal.visible ? ' is-visible' : ''}`}
            style={{ transitionDelay: '.15s' }}
          >
            <div className="flex items-center gap-3">
              <div className="w-7 h-px" style={{ background: 'rgba(245,158,11,.45)' }} />
              <span className="font-royal text-[9px] uppercase font-bold tracking-[.45em]" style={{ color: 'rgba(245,158,11,.58)' }}>
                ॐ The Vedic Seer ॐ
              </span>
              <div className="w-7 h-px" style={{ background: 'rgba(245,158,11,.45)' }} />
            </div>

            <div>
              <h2 className="font-royal text-4xl lg:text-[52px] font-normal text-white leading-tight tracking-tight">
                Meet <span className="bg-linear-to-r from-goldPrimary via-amber-300 to-goldAccent bg-clip-text text-transparent">Maharaj Ji</span>
              </h2>
              <p className="text-[9px] uppercase tracking-[.36em] mt-2 font-royal" style={{ color: 'rgba(245,158,11,.48)' }}>
                Jyotish Acharya · Palmist · Vastu Consultant
              </p>
            </div>

            <div className="flex items-center gap-4">
              <div className="flex-1 max-w-22.5 h-px" style={{ background: 'linear-gradient(90deg,rgba(245,158,11,.35),transparent)' }} />
              <span className="font-royal text-sm" style={{ color: 'rgba(245,158,11,.38)' }}>ॐ</span>
              <div className="flex-1 max-w-22.5 h-px" style={{ background: 'linear-gradient(90deg,transparent,rgba(245,158,11,.35))' }} />
            </div>

            <p className="text-[14px] leading-[1.88]" style={{ color: 'rgba(255,255,255,.42)', fontWeight: 300 }}>
              Trained in the ancient traditions of Jyotish Shastra, Maharaj Ji blends classical Parashari methods, Nadi astrology, and
              deep intuitive wisdom to deliver precise, life-changing guidance to seekers across {stats.countries}+ countries.
            </p>

            <div className="flex items-stretch gap-0 py-1">
              <div className="pr-7 text-center">
                <StatCounter target={stats.session} suffix="K+" className="font-royal text-3xl font-bold text-goldPrimary leading-none" />
                <p className="text-[8px] uppercase tracking-[.28em] mt-1.5 font-semibold" style={{ color: 'rgba(255,255,255,.28)' }}>
                  Sessions
                </p>
              </div>
              <div className="w-px shrink-0" style={{ background: 'rgba(255,255,255,.08)' }} />
              <div className="px-7 text-center">
                <StatCounter target={stats.countries} suffix="+" className="font-royal text-3xl font-bold text-goldPrimary leading-none" />
                <p className="text-[8px] uppercase tracking-[.28em] mt-1.5 font-semibold" style={{ color: 'rgba(255,255,255,.28)' }}>
                  Countries
                </p>
              </div>
              <div className="w-px shrink-0" style={{ background: 'rgba(255,255,255,.08)' }} />
              <div className="pl-7 text-center">
                <StatCounter target={stats.experience} suffix="+" className="font-royal text-3xl font-bold text-goldPrimary leading-none" />
                <p className="text-[8px] uppercase tracking-[.28em] mt-1.5 font-semibold" style={{ color: 'rgba(255,255,255,.28)' }}>
                  Years Exp.
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              {EXPERTISE_CHIPS.map((chip) => (
                <span
                  key={chip}
                  className="about-chip px-3 py-1.5 rounded-full border text-[9px] font-semibold tracking-wider uppercase cursor-default transition-all duration-300 hover:bg-goldPrimary/12"
                  style={{ borderColor: 'rgba(245,158,11,.2)', color: 'rgba(245,158,11,.72)' }}
                >
                  {chip}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href={appUrl("jyotish", 'book-maharaj-ji')}
                className="shine-btn bg-linear-to-r from-goldAccent to-goldPrimary text-astroDark font-bold text-[11px] uppercase tracking-[.22em] px-8 py-3.5 rounded-full shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-goldPrimary/20"
              >
                Book A Session
              </a>
              <a
                href="#"
                className="group flex items-center gap-2.5 text-white/40 hover:text-goldPrimary transition-colors duration-300"
              >
                <span className="w-8 h-8 rounded-full flex items-center justify-center border border-white/10 group-hover:border-goldPrimary/30 transition-colors duration-300">
                  <svg className="w-3 h-3 ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </span>
                <span className="text-[10px] uppercase tracking-widest font-semibold">Watch Story</span>
              </a>
            </div>

            <div className="flex items-center gap-3 pt-2" style={{ borderTop: '1px solid rgba(255,255,255,.06)' }}>
              <div
                className="w-5 h-5 rounded-full flex items-center justify-center text-[9px] shrink-0"
                style={{ background: 'rgba(245,158,11,.15)', color: '#F59E0B' }}
              >
                ✓
              </div>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 opacity-60">
                <span className="text-[8px] uppercase tracking-[.3em] font-semibold">
                  Recognised by
                </span>
                {RECOGNITION.map((org, i) => (
                  <span key={org} className="contents">
                    {i > 0 && <span className='text-[7px]'>✦</span>}
                    <span className="text-[8px] uppercase tracking-[.2em]">
                      {org}
                    </span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
